/**
 * component - the parent component which to query
 * elementsToQuery - an array of objects to query {el, name}
 *    ex. const elementsToQuery = [{el:'h2', name: 'Subsection-title'}, dataset:[]' ]
 *        el: the element to query, name: descriptive name for the element, dataset: an optional array listing data attributes to query. The value of the data attribute = description
 * element - an Object of the element from query results
 *
 *
 * TODO: Add option to limit the number of rows/cells queried before loop
 * TODO: Update script to query div's with background images
 */

export default function (component, elementsToQuery) {
  const qaAttribute = 'data-qa'
  const listOfIds = []

  elementsToQuery.forEach((element) => {
    const queryResult = [...component.querySelectorAll(element.el)]
    const name = element.name
    let count = 1

    queryResult.forEach((queriedElement) => {
      const keys = Object.keys(queriedElement.dataset)

      if (element.dataset && element.dataset.length) {
        let description = ''

        element.dataset.forEach((dataAttribute) => {
          // Verifying that the data attribute exists and retreiving the value of the dataset from the queried element
          if (keys.indexOf(dataAttribute) >= 0) {
            description = `${queriedElement.dataset[dataAttribute]}`
            queriedElement.setAttribute(
              qaAttribute,
              `${name}-${description}-${count}`
            )
            count++
          }
        })
      } else {
        queriedElement.setAttribute(qaAttribute, `${name}-${count}`)
        count++
      }

      if (queriedElement.dataset.qa) {
        listOfIds.push(queriedElement.dataset.qa)
      }
    })
  })

  return listOfIds
}
